export default __webpack_public_path__ + "static/media/chip.5d57dd3a.gif";